/**
 * 개발 환경 전용 콘솔
 * DEV/LOCAL 환경에서만 콘솔 출력이 작동하며, 프로덕션에서는 자동으로 무시됩니다.
 */

// 개발 환경 체크
const isDevelopment = (() => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const env = import.meta.env.VITE_ENV
    return env === 'DEV' || env === 'LOCAL'
  }
  return false
})()

// 빈 함수 (프로덕션용)
const noop = () => {}

// devConsole 타입 정의
type DevConsole = {
  log: typeof console.log
  error: typeof console.error
  warn: typeof console.warn
  info: typeof console.info
  debug: typeof console.debug
  table: typeof console.table
  time: typeof console.time
  timeEnd: typeof console.timeEnd
  group: typeof console.group
  groupEnd: typeof console.groupEnd
  groupCollapsed: typeof console.groupCollapsed
  clear: typeof console.clear
  count: typeof console.count
  countReset: typeof console.countReset
  assert: typeof console.assert
  trace: typeof console.trace
  dir: typeof console.dir
  dirxml: typeof console.dirxml
  profile: typeof console.profile
  profileEnd: typeof console.profileEnd
  timeLog: typeof console.timeLog
  timeStamp: typeof console.timeStamp
}

/**
 * 개발 환경에서만 작동하는 콘솔
 * 
 * @example
 * ```typescript
 * import { devConsole } from '~/common/devConsole'
 * 
 * devConsole.log('개발 환경에서만 출력됨')
 * devConsole.error('에러 디버깅', error)
 * devConsole.table(data)
 * ```
 */
export const devConsole: DevConsole = new Proxy(console, {
  get(target, prop: string) {
    if (!isDevelopment) {
      // 프로덕션에서는 아무것도 하지 않는 빈 함수 반환
      return noop
    }
    // 개발 환경에서는 원본 console 메서드 반환
    const method = target[prop as keyof Console]
    if (typeof method === 'function') {
      return method.bind(target)
    }
    return method
  }
}) as DevConsole